export default "__VITE_ASSET__CmCqohR5__"